import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader} from 'semantic-ui-react';
import {ONLY_HAVE_ONE_ROW} from '../../constants';
import {Actions} from '../../../common/actions';
import PrincipalCode from './principal';
import PartInfo from './partInfo';
import Substitute from './substitute';
import EquivalentCodes from './equivalences';

class OrderGrid extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }
  
  componentDidMount() {
    const {partLength, part} = this.props;
    if (partLength === ONLY_HAVE_ONE_ROW) {
      const {code} = part.original;
      this.props.selectDealerEmergingOrderCode(code);
    }
  }

  renderCodeOptions() {
    const {loading, part} = this.props;
    
    if (!loading) {
      return (<React.Fragment>
        <PrincipalCode original={part.original} substitute={part.substitute}/>
        <Substitute substitute={part.substitute} />
        <EquivalentCodes equivalences={part.equivalences} />
      </React.Fragment>
      );
    }

    return (
      <Table.Row>
        <Table.Cell />
        <Table.Cell colSpan='9'>
          <Loader active inline='centered'>Buscando...</Loader>
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    const {part, selectCode} = this.props;
    const {original} = part;
    const showPartCode = original.code === selectCode;

    return (
      <React.Fragment>
        {this.renderCodeOptions()}
        { showPartCode && <PartInfo /> }
      </React.Fragment>
    );
  }
}

const {selectDealerEmergingOrderCode} = Actions;

const mapStateToProps = (state) => {
  return {
    'selectCode': state.dealerEmergingOrders.selectedCode,
  };
};
export default connect(mapStateToProps, {
  selectDealerEmergingOrderCode,
})(OrderGrid);
